// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"success_subTitle__YIQd1","subTitleLink":"success_subTitleLink__3nYjS"};